export default __webpack_public_path__ + "google_play.3a653de.svg";